// @ts-nocheck
import styled from 'styled-components';

export const CartographyAdvanceSettingsStyle = styled.div`
  .innerControls {
    &__cartographyCountrySelector, &__cartographyLevelSelector {
      label {
        margin: 8px 0;
        color: ${props => props.theme.uiColors.selectorLabel};
        font-size: 9px;
      }
      .singleSelectorComponent__control {
        height: 32px;
        width: 182px;
      }
      .singleSelectorComponent__menu {
        width: 182px;
      }
      .multiSelector {
        .selectorComponent__displaySelector.tiny {
          width: 182px;
        }
      }
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 16px;
  .innerControls {
    &__trashButton {
      height: 32px;
      padding: 10px 7.9px;
    }
    &__applyButton {
      height: 32px;
      width: 200px;
    }
  }
`;
